<template>
  <dashboard></dashboard>
</template>

<script>
import Dashboard from '@/views/Dashboard.vue'
export default {
  name: 're-dashboard',
  components: {
    Dashboard
  }

}
</script>

<style>

</style>
